// extracted by mini-css-extract-plugin
export default {"alertContainer":"Alert_alertContainer__BxfJD","success":"Alert_success__lTqpx","error":"Alert_error__xscaR","message":"Alert_message__xP8de","iconVariant":"Alert_iconVariant__uziN8"};